import React, { useMemo } from "react";
import { OverlayView, OverlayViewF } from "@react-google-maps/api";
import { HomeOutlined } from "@mui/icons-material";
import useTranslation from "../../../../shared/hooks/useTranslation";
import { dt } from "../../../../shared/themes/redesignTokens";

// ===================================================================
//  DESIGN TOKENS
// ===================================================================


const HOME_MARKER_COLOR = dt.blue;
const HOME_MARKER_SIZE = 40;

// ===================================================================
//  COMPONENT
// ===================================================================

interface HomeMarkerProps {
  position: { lat: number; lng: number };
}

const HomeMarker: React.FC<HomeMarkerProps> = ({ position }) => {
  const { translate } = useTranslation(["serviceBoard"]);

  const pos = useMemo(() => ({ lat: position.lat, lng: position.lng }), [position.lat, position.lng]);

  const getPixelPositionOffset = useMemo(
    () => () => ({ x: -(HOME_MARKER_SIZE / 2), y: -(HOME_MARKER_SIZE / 2 + 10) }),
    []
  );

  return (
    <OverlayViewF
      position={pos}
      mapPaneName={OverlayView.OVERLAY_LAYER}
      getPixelPositionOffset={getPixelPositionOffset}
    >
      <div
        style={{
          position: "relative",
          width: HOME_MARKER_SIZE,
          height: HOME_MARKER_SIZE,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pointerEvents: "none",
        }}
      >
        {/* Main circle */}
        <div
          style={{
            width: HOME_MARKER_SIZE,
            height: HOME_MARKER_SIZE,
            borderRadius: "50%",
            backgroundColor: HOME_MARKER_COLOR,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
            border: "3px solid #FFFFFF",
          }}
        >
          <HomeOutlined
            style={{
              color: "#FFFFFF",
              fontSize: "22px",
            }}
          />
        </div>

        {/* Label below */}
        <div
          style={{
            position: "absolute",
            bottom: -18,
            left: "50%",
            transform: "translateX(-50%)",
            fontFamily: dt.font,
            fontSize: "10px",
            fontWeight: 700,
            color: dt.textPrimary,
            whiteSpace: "nowrap",
            textShadow: "0 1px 3px rgba(255,255,255,0.9)",
            userSelect: "none",
            letterSpacing: "0.3px",
          }}
        >
          {translate("mapHomeLabel")}
        </div>
      </div>
    </OverlayViewF>
  );
};

export default React.memo(HomeMarker);
